import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store';
import { BtiHouseData, IBtiHouseDataStoreProps } from './index';
import { isLayoutSubscribeAddress } from '../subscription_address/experiments/layout_subscribe_address';
import {
  setVisible,
  fetchCreateSubscriptionRequest,
} from '../../store/popups/subscription_address';
import { ICreateSubscriptionRequest } from '../../repositories/monolithPython/v1/create-subscription';

export function mapStateToProps(state: IState): IBtiHouseDataStoreProps {
  const { offerData: { offer } } = state;

  const geoHouse = offer.geo && offer.geo.address &&
    offer.geo.address.find(item => item.type === 'house');
  const isLayoutSubscribeAddressExperiment = Boolean(geoHouse && isLayoutSubscribeAddress(state.experiments));

  return {
    houseData: state.offerData.bti && state.offerData.bti.houseData || null,
    jkName: state.offerData.offer.category === 'newBuildingFlatSale' && state.offerData.newObject
      ? state.offerData.newObject.name
      : '',
    offer: state.offerData.offer,
    roomCount: state.offerData.offer.roomsCount || null,

    isLayoutSubscribeAddressExperiment,
    isOpen: state.subscriptionAddress.isOpen,
    isLoad: state.subscriptionAddress.isLoad,
    isSubscribe: state.subscriptionAddress.isSubscribe,
    globalError: state.subscriptionAddress.globalError,
    user: state.offerData.user,
    pushSubscribed: state.pushSubscribed,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>) {
  return {
    setVisible: (isOpen: boolean) => dispatch(setVisible(isOpen)),
    fetchCreateSubscription: (parameters: ICreateSubscriptionRequest) => {
      return dispatch(fetchCreateSubscriptionRequest(parameters));
    },
  };
}

// tslint:disable-next-line:no-any
export const BtiHouseDataContainer = connect(mapStateToProps, mapDispatchToProps)(BtiHouseData);
